import { Layout, message } from 'antd';
import AppRouter from "./components/AppRouter";
import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { Utils } from './utils';
import { setAuth, setUserInfo } from './store/users';
import * as Sentry from '@sentry/react';
import socket from './socket';
import { useStoreDispatch } from './store';



function App() {
  const dispatch = useStoreDispatch();
  const userInfo = sessionStorage.getItem('_yl105000');

  useEffect(() => {
    if (userInfo) {
      const jRes = Utils.decrypt(userInfo);
      if (Object.keys(jRes).length === 0) {
        Cookies.remove('Bearer');
        dispatch(setAuth(false));
      }else {
        dispatch(setUserInfo(jRes));
        dispatch(setAuth(true));
      }
    }else {
      dispatch(setAuth(false));
      Cookies.remove('Bearer');
      sessionStorage.removeItem('_yl105000');
    }
    socket.on("error", resError);
    return () => {
      socket.off("error", resError);
    }
  }, []);

  const resError = (response: string) => {
    message.error(response);
  };

  function FallbackComponent() {
    return <div>An error has occurred</div>;
  }

  return (
    <Sentry.ErrorBoundary fallback={FallbackComponent} showDialog>
    <Layout>
      <Layout.Content>
          <AppRouter/>
      </Layout.Content>
    </Layout>
    </Sentry.ErrorBoundary>
  );
}

export default App;
